"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var couponApi = _interopRequireWildcard(require("../../marketing/coupon/api"));
var userApi = _interopRequireWildcard(require("@/api/user"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      selectVisible: false,
      constants: this.$constants,
      listPram: {
        name: '',
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      submitInfo: {}
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    initOpen: function initOpen() {
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.submitInfo = _objectSpread({}, pram);
      this.listPram.name = '';
      this.selectVisible = true;
      this.handlerGetListData(this.listPram);
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = this.submitInfo || {},
        userType = _ref.userType,
        customerIdList = _ref.customerIdList;
      this.listLoading = true;
      couponApi.couponLists(_objectSpread(_objectSpread({}, pram), {}, {
        customerIdList: userType == 2 && customerIdList !== null && customerIdList !== void 0 && customerIdList.length ? customerIdList : null
      })).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    handerSubmit: function handerSubmit(couponId) {
      var _this2 = this;
      this.listLoading = true;
      var _ref2 = this.submitInfo || {},
        userType = _ref2.userType,
        groupId = _ref2.groupId,
        tagId = _ref2.tagId,
        miniProgramId = _ref2.miniProgramId,
        userIds = _ref2.userIds,
        _ref2$userSource = _ref2.userSource,
        userSource = _ref2$userSource === void 0 ? 0 : _ref2$userSource;
      var TYPE_MAP = {
        1: {
          userIds: userIds === null || userIds === void 0 ? void 0 : userIds.map(function (item) {
            return item.uid;
          })
        },
        2: {
          customerIdList: miniProgramId
        },
        3: {
          groupId: groupId
        },
        4: {
          tagId: tagId
        }
      };
      userApi.sendCoupons(_objectSpread({
        couponId: couponId,
        userType: userType,
        userSource: userSource
      }, TYPE_MAP[userType])).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.listLoading = false;
        _this2.selectVisible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.listLoading = false;
      });
    }
  }
};